import { render, staticRenderFns } from "./mediaAccount.vue?vue&type=template&id=78bdf2c4"
import script from "./mediaAccount.vue?vue&type=script&lang=js"
export * from "./mediaAccount.vue?vue&type=script&lang=js"
import style0 from "./mediaAccount.vue?vue&type=style&index=0&id=78bdf2c4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports